import { IOrderDataState } from '../hooks/order';
import { IUser } from '../shared/interfaces/user-interfaces';

export const setToken = (token: string): void => {
  localStorage.setItem('@shop-calendar:token', token);
};
export const getToken: () => string | null = () =>
  localStorage.getItem('@shop-calendar:token');

export const clearToken: () => void = () => {
  localStorage.removeItem('@shop-calendar:token');
};

export const setUser: (user: IUser) => void = (user: IUser) => {
  localStorage.setItem('@shop-calendar:user', JSON.stringify(user));
};
export const getUser: () => IUser | null = () =>
  localStorage.getItem('@shop-calendar:user')
    ? JSON.parse(localStorage.getItem('@shop-calendar:user') || '')
    : null;
export const clearUser: () => void = () => {
  localStorage.removeItem('@shop-calendar:user');
};

export const setOrderData: (orderData: IOrderDataState) => void = (
  orderData: IOrderDataState,
) => {
  localStorage.setItem('@shop-calendar:orderData', JSON.stringify(orderData));
};
export const getOrderData: () => IOrderDataState | null = () =>
  localStorage.getItem('@shop-calendar:orderData')
    ? JSON.parse(localStorage.getItem('@shop-calendar:orderData') || '')
    : null;
export const clearOrderData: () => void = () => {
  localStorage.removeItem('@shop-calendar:orderData');
};
